"use client"

import { Button, CircularProgress, Box } from "@mui/material"
import { motion } from "framer-motion"

const LoadingButton = ({ loading = false, children, disabled, startIcon, ...props }) => {
  return (
    <Button disabled={loading || disabled} startIcon={!loading && startIcon} {...props}>
      {loading ? (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <CircularProgress
            size={24}
            color="inherit"
            sx={{ mr: 1 }}
            component={motion.svg}
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Number.POSITIVE_INFINITY, ease: "linear" }}
          />
          <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
            Loading...
          </motion.span>
        </Box>
      ) : (
        children
      )}
    </Button>
  )
}

export default LoadingButton

